import {ReportRequestParametersObjectObject} from 'common/api/api.ts'
import {CommonRoutes} from 'common/context/commonRoutes.ts'
import {FormMode} from 'common/util/Util.tsx'
import {ReportFormAdvertiser} from '@/pages/report/ReportFormAdvertiser.tsx'

export const TrackerEventListAdvertiser = () => (
  <ReportFormAdvertiser
    mode={FormMode.create}
    reportType={ReportRequestParametersObjectObject.TypeEnum.Tracker}
    savedReportBaseRoute={CommonRoutes.TRACKER_EVENT_REPORT}
    title="New Tracker Report"
  />
)
